<template>
  <div class="archive-recyle-page">
    <div class="tcf-row">
      <el-tabs type="border-card" :value="activeName" @tab-click="tabClick">
        <el-tab-pane v-for="(item, index) in fileKinds" :key="index" :label="item.name" :name="item.id + ''">
          <file-pane v-if="item.id > 0 && item.id == activeName" :kind-id="item.id" :kind-name="item.name" recycle>
          </file-pane>
          <div v-else style="min-height: 75vh;"></div>
        </el-tab-pane>
      </el-tabs>

    </div>
  </div>
</template>

<script>
  import {
    getFileKinds
  } from '@/api/archive'

  import {
    getUser
  } from '@/utils/auth'

  import FilePane from './components/FilePane.vue';

  export default {
    name: 'archive-recyle',
    components: {
      FilePane
    },
    computed: {
      user: getUser,
    },
    data() {
      return {
        allKinds: [],
        fileKinds: [{
          name: '文件',
          id: -1
        }],
        activeName: '-1',
        tempRoute: {}
      }
    },
    watch: {
      $route(to, from) {
        let kind = to && to.params && to.params.id
        if (kind) {
          this.activeName = kind + ''
        }
      },
    },
    created() {
      this.tempRoute = Object.assign({}, this.$route)
      this.getKinds()
    },
    methods: {
      tabClick(e) {
        this.activeName = e.name
        this.$router.push({
          query: {
            directory: 0
          }
        });

        this.changeCurrentKind()
      },

      changeCurrentKind() {
        let kindObj = {}
        const index = this.allKinds.findIndex(r => r.id == this.activeName);
        if (index > -1) kindObj = this.allKinds[index] || {}

        if (kindObj && kindObj.id) {
          this.fileKinds = [{
            ...kindObj
          }]
        }

        const pageTitle = `档案库回收站${kindObj.name ? '-' + kindObj.name : ''}`
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, {
          title: pageTitle
        })
        this.$store.dispatch('tagsView/updateVisitedView', route)
      },

      getKinds() {
        getFileKinds({}).then(response => {
          // console.log(response.data)
          this.allKinds = response.data || []

          let kindObj = {}
          let kind = this.$route.params && this.$route.params.id
          if (kind) {
            this.activeName = kind + ''
            const index = this.allKinds.findIndex(r => r.id == this.activeName);
            if (index > -1) kindObj = this.allKinds[index] || {}
          } else if (this.allKinds.length > 0) {
            kindObj = this.allKinds[0] || {}
            this.activeName = this.allKinds[0].id + ''
            this.$router.replace({
              query: {
                directory: 0
              }
            });
          }

          if (kindObj && kindObj.id) {
            this.fileKinds = [{
              ...kindObj
            }]
          }

          // 管理员
          if (this.user.fileRight === 'admin') {
            this.fileKinds = [...this.allKinds]
          }

          this.changeCurrentKind()
        }).catch(() => {})
      },

    }
  }
</script>

<style lang="scss" scoped>
  .archive-recyle-page {
    height: 100%;
    width: 100%;
  }
</style>
